const translation = {
    title: 'Welcome to Laboria!',
    language: 'Language',
    nav: {
        home: 'Home',
        aboutUs: 'About Us',
        services: 'Services',
        h2aVisa: 'H2-A Visa',
        h2bVisa: 'H2-B Visa',
        ourServices: 'Our Services',
        contact: 'Contact',
        contactUs: 'Contact Us',
        openings: 'Openings',
        steps: 'Steps'
    },
    landing: {
        applyNow: 'Apply Now',
        contactUs: 'Contact Us',
        showMore: 'Contact Us',
        clientTalentTitle: 'Are you looking for top talent for your seasonal job?',
        clientTalentDescription: 'Find the qualified staff you need',
        legallyUs: `Don't you know how work legally in the UNITED STATES?`,
        helpYou: 'We help you!',
        applicantTitle: 'Would you like to apply for a job opportunity?',
        applicantDescription: 'We will help you during the proccess',
        clientTitle: 'Are you looking for top-notch resources for your temporary vacancies?',
        clientDescription: 'Acquire our services.',
        process: {
            identify: 'We identify your skills',
            find: 'We find the best job for you',
            handle: 'We handle the process'
        }
    },
    openings: {
        title: 'Job Openings',
        details: {
            description: "Description",
            location: "Location",
            salary: "Salary",
            apply: "Apply"
        },
        list: {
            position: 'Position',
            field: 'Field',
            description: 'Description',
            location: 'Location',
            options: 'Options'
        }
    },
    steps: {
        personalInfo: 'Personal information',
        dsForm: 'DS-160'
    },
    forms: {
        yes: 'Yes',
        no: 'No',
        personalInfo: {
            idIsNotValid: 'There is an existing application with this Identification number',
            howManyKidsRequired: 'This field is required when you have kids',
            howManyKidsMin: 'Must be at least 1',
            howManyKidsPattern: 'Must be a valid number',
            id: 'ID',
            name: 'First Name',
            middleName: 'Middle Name',
            lastName: 'Last Name',
            gender: 'Gender',
            maritalStatus: 'Marital Status',
            partnerName: 'Partner Name',
            haveKids: 'Do you have kids?',
            howManyKids: 'How many kids do you have?',
            educationLevel: 'Education Level',
            profession: 'Profession or occupation',
            speaksEnglish: 'Do you speak English?',
            englishLevel: 'English Level',
            workExperience: 'Work Experience',
            workExperienceMaxLength: 'Work experience must be 200 characters or less',
            workExperienceTooltip: 'Add the most relevant work experience information',
            havePassport: 'Do you have a passport?',
            passportExpiration: 'Passport Expiration Date',
            passportExpirationRequired: 'Passport expiration date is required',
            visa: 'Have you received any type of United States visa?',
            country: 'Country',
            state: 'State',
            city: 'City',
            address: 'Address',
            phone: 'Phone number',
            birthDate: 'Birthdate',
            haveEmail: 'Do you have an email?',
            email: 'E-mail',
            emailRequired: 'Email is required',
            emailPattern: 'Please enter a valid email address',
            next: 'Next'
        },
        genderOptions: {
            male: 'Male',
            female: 'Female',
            other: 'Prefer not to say'
        },
        maritalStatusOptions: {
            single: 'Single',
            married: 'Married',
            divorced: 'Divorced',
            widowed: 'Widowed',
            separated: 'Separated'
        },
        educationalLevels: {
            noFormalEducation: 'No formal education',
            primaryEducation: 'Primary education',
            secondaryEducation: 'Secondary education',
            vocationalQualification: 'Vocational qualification',
            bachelorDegree: 'Bachelor degree',
            masterDegree: 'Master degree',
            doctorate: 'Doctorate or higher'
        },
        englishLevels: {
            basic: 'Basic',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
            fluent: 'Fluent'
        },
        visaTypes: {
            No: "No",
            B2: "Visitor Visa (B-2)",
            B1: "Business Visa (B-1)",
            H1B: "Temporary Work Visa (H-1B)",
            F1: "Student Visa (F-1)",
            J1: "Exchange Visitor Visa (J-1)",
            K1: "Fiancé(e) Visa (K-1)",
            CR1: "Spouse Visa (CR-1/IR-1)",
            E2: "Investor Visa (E-2)",
            O1: "Artist/Academic Visa (O-1)",
            R1: "Religious Worker Visa (R-1)"
        },
        professions: {
            agriculture: "Agriculture/Farming",
            construction: "Construction Worker",
            hospitality: "Hospitality/Tourism",
            manufacturing: "Manufacturing",
            landscaping: "Landscaping/Gardening",
            housekeeping: "Housekeeping",
            cooking: "Cook/Chef",
            mechanic: "Mechanic",
            electrician: "Electrician",
            plumber: "Plumber",
            painter: "Painter",
            driver: "Driver",
            security: "Security Guard",
            cleaner: "Cleaner",
            waiter: "Waiter/Waitress",
            cashier: "Cashier",
            sales: "Sales Representative",
            fishing: "Fishing",
            textile: "Textile Worker",
            teacher: "Teacher",
            nurse: "Nurse",
            engineer: "Engineer",
            softwareEngineer: "Software Engineer",
            other: "Other"
        },
        dsForm: {
            haveDirectRelativeInUS: "Do you have any direct relatives in the United States, excluding your parents?",
            relatives: "What is your relationship with them?",
            relativesRequired: "Please select a relationship",
            cousin: "Cousin",
            brotherOrSister: "Brother or Sister",
            brotherInLaw: "Brother-in-law / Sister-in-law",
            husbandOrWife: "Husband or Wife",
            uncles: "Uncle or Aunt",
            deniedVisa: "Have you ever been denied a visa?",
            howLongWasVisaDenied: "How long ago was your visa denied?",
            howLongWasVisaDeniedRequired: "This field is required when visa was denied",
            lessThanOneYear: "Less than one year",
            oneToFiveYears: "Between 1 and 5 years",
            moreThanFiveYears: "More than 5 years",
            canceledVisa: "Has your visa ever been canceled?",
            whenWasVisaCanceled: "When was your visa canceled?",
            whenWasVisaCanceledRequired: "Date is required when visa was canceled",
            citizenRequest: "Have you ever applied for citizenship in the United States?",
            currentlyWithVisaProcess: "Are you currently in a visa process?",
            whatKindOfVisaIsProcessing: "What kind of visa is being processed?",
            whatKindOfVisaIsProcessingRequired: "Visa type is required when in process",
            outOfCountryLastFiveYears: "Have you been out of the country in the last 5 years?",
            visitedCountries: "Which countries have you visited?",
            haveBeenOut: "Have you resided in another country for more than 6 months after turning 16?",
            triedEnterIllegallyToUs: "Have you ever tried to enter the United States illegally?"
        },
        contact: {
            companyName: "Company Name",
            companyDescription: "Company Description",
            contactName: "Contact Name",
            phoneNumber: "Phone Number",
            country: "Country",
            state: "State",
            city: "City",
            address: "Address",
            email: "Email",
            message: "Message",
            submit: "Submit"
        }
    },
    auth: {
        signUp: {
            email_label: 'Your email address',
            password_label: 'Create your password',
            email_input_placeholder: 'Your email address',
            password_input_placeholder: 'Your password',
            button_label: 'Sign up',
            loading_button_label: 'Signing up ...',
            link_text: "Don't have an account? Sign up",
            confirmation_text: "Check your email for the confirmation link"
        },
        signIn: {
            email_label: "Email address",
            password_label: "Your Password",
            email_input_placeholder: "Your email address",
            password_input_placeholder: "Your password",
            button_label: "Sign in",
            loading_button_label: "Signing in ...",
            social_provider_text: "Sign in with {{provider}}",
            link_text: "Already have an account? Sign in"
        },
        forgottenPassword: {
            email_label: "Email address",
            password_label: "Your Password",
            email_input_placeholder: "Your email address",
            button_label: "Send reset password instructions",
            loading_button_label: "Sending reset instructions ...",
            link_text: "Forgot your password?",
            confirmation_text: "Check your email for the password reset link"
        }
    },
    client: {
        setUpTitle: 'Before starting, we just need to fill out some information.',
        email: 'Email',
        organizationName: 'Organization Name',
        phoneNumber: 'Phone number'
    },
    whatWeDo: {
        findPeople: 'We find people that will help make your business a success.',
        ethicalRecruitment: 'We ensure an ethical recruitment',
        process: 'process',
        deliverTalent: 'We deliver the best talent in Latin America'
    },
    confirmation: {
        thankYou: 'Thank you for your interest!',
        emailSent: 'We have sent you a confirmation email',
        instructions: 'Please check your inbox and follow the instructions in the email. We\'ll be in touch with you soon.',
        backHome: 'Back Home'
    },
    aboutUs: {
        whatWeDo: 'What we do?',
        description: `At LABORIA, we specialize in international recruitment, connecting qualified talent from Latin America with companies in the United States that need to fill temporary positions in sectors such as hospitality, construction, landscaping, and more. We stand out for offering a comprehensive service that includes recruitment, selection, and immigration procedures, ensuring regulatory compliance at every stage of the process.
Our commitment is to provide reliable and effective labor solutions, optimizing our clients' workforce while transforming the life opportunities of our collaborators. With a focus on excellence, integrity, and transparency, LABORIA not only facilitates legal processes but also builds bridges between opportunities and personal development, driving the success of all involved.`,
        howWeDoIt: 'How we do it?',
        howWeDoItDescription: `At LABORIA, we work under a comprehensive and professional approach that ensures effective results:`,
        howWeDoitList: {
            step1: `Search and selection: We identify and evaluate candidates who meet our clients' specific requirements, ensuring reliable and qualified talent.`,
            step2: 'Immigration management: We handle all necessary procedures, including H2A and H2B visas, ensuring legal compliance at every stage.',
            step3: 'Continuous support: We maintain constant communication with employers and workers, resolving doubts and offering support throughout the process.',
            step4: 'Transparency and reliability: We clearly inform the steps of the process, providing confidence to all involved.',
        },
        ourMision: 'Our Mission',
        mision: 'We connect companies in the United States with qualified talent from Latin America, offering comprehensive labor solutions in sectors such as hospitality, construction, gardening, and more. We transform lives through safe and ethical temporary job opportunities, ensuring regulatory compliance and excellence in service. We are the trusted bridge between companies and collaborators, promoting economic and professional growth for both.',
        ourVision: 'Our Vision',
        vision: 'To become the leader in international recruitment in Honduras, recognized for our excellence, innovation, and commitment to legal and ethical processes. In the medium term, expand our operations to other Latin American countries, positioning ourselves as the first choice for companies in the United States seeking qualified talent and for workers who want to build a better future through safe job opportunities. We aspire to transform the international labor market, promoting equal opportunities and strengthening communities on both sides of the border.'
    },
    footer: {
        companyDescription: 'Connecting talent with opportunities',
        businessHours: 'Business Hours: Monday to Friday, 8 AM - 5 PM (Honduras Central America Time)',
        quickLinks: 'Quick Links',
        followUs: 'Follow Us',
        allRightsReserved: 'All rights reserved.'
    },
    common: {
        back: 'Back'
    },
    h2aVisa: {
        title: 'H2-A Visa',
        subtitle: 'Temporary Agricultural Workers Program - Connecting skilled agricultural workers with American farms',
        whatIsTitle: 'What is the H2-A Visa?',
        whatIsDescription1: 'The H2-A visa is a non-immigrant visa that allows U.S. employers to bring foreign nationals to the United States to fill temporary agricultural jobs.',
        whatIsDescription2: 'This program is specifically designed to address seasonal labor shortages in the agricultural sector, ensuring that American farms can maintain their productivity during peak harvest seasons.',
        whatIsDescription3: 'The H2-A visa is renewable and allows workers to stay in the U.S. for up to one year, with the possibility of extensions for up to three years.',
        whoIsForTitle: 'Who is this Visa For?',
        employersTitle: 'For U.S. Employers:',
        employersDescription: 'Agricultural businesses, farms, and ranches that need temporary workers for seasonal agricultural work.',
        workersTitle: 'For Foreign Workers:',
        workersDescription: 'Skilled agricultural workers from eligible countries who are seeking temporary employment opportunities in the United States.',
        requirementsTitle: 'Basic Requirements:',
        requirementsDescription: 'Must be at least 18 years old, have agricultural experience, and be from a country that has a treaty with the U.S. for this type of visa.',
        benefitsTitle: 'Key Benefits of the H2-A Visa Program',
        benefit1: 'Legal Work',
        benefit1Desc: 'Work legally in the U.S. with proper documentation',
        benefit2: 'Fair Wages',
        benefit2Desc: 'Guaranteed fair wages and working conditions',
        benefit3: 'Housing',
        benefit3Desc: 'Employer-provided housing or housing allowance',
        benefit4: 'Transportation',
        benefit4Desc: 'Transportation to and from the U.S. included',
        howWeHelpTitle: 'How Laboria Helps with H2-A Visa Processing',
        howWeHelpSubtitle: 'We handle the entire process from start to finish',
        step1: '1. Application',
        step1Desc: 'Complete visa application and documentation',
        step2: '2. Processing',
        step2Desc: 'Handle all government processing and approvals',
        step3: '3. Support',
        step3Desc: 'Ongoing support throughout the process',
        step4: '4. Success',
        step4Desc: 'Ensure successful visa approval and arrival',
        clientSectionTitle: 'For U.S. Employers & Agricultural Businesses',
        clientBenefitsTitle: 'Why Choose H2-A Workers?',
        clientBenefit1: 'Reliable seasonal workforce during peak harvest times',
        clientBenefit2: 'Skilled workers with agricultural experience',
        clientBenefit3: 'Compliance with U.S. labor laws and regulations',
        clientBenefit4: 'Flexible employment periods (up to 3 years)',
        clientRequirementsTitle: 'Employer Requirements',
        clientRequirement1: 'Demonstrate temporary or seasonal need for workers',
        clientRequirement2: 'Pay prevailing wage rates and provide housing',
        clientRequirement3: 'Cover transportation costs to and from the U.S.',
        clientRequirement4: 'Ensure workers\' compensation coverage',
        clientCtaButton: 'Hire H2-A Workers',
        applicantSectionTitle: 'For Agricultural Workers Seeking U.S. Employment',
        applicantBenefitsTitle: 'Benefits for Workers',
        applicantBenefit1: 'Legal work authorization in the United States',
        applicantBenefit2: 'Competitive wages with fair working conditions',
        applicantBenefit3: 'Employer-provided housing or housing allowance',
        applicantBenefit4: 'Round-trip transportation included',
        applicantRequirementsTitle: 'Worker Requirements',
        applicantRequirement1: 'Minimum 18 years of age',
        applicantRequirement2: 'Proven agricultural work experience',
        applicantRequirement3: 'Citizen of eligible treaty country',
        applicantRequirement4: 'Willingness to work seasonal agricultural jobs',
        applicantCtaButton: 'Apply for H2-A Jobs',
        applicantCtaSubtext: 'Browse available agricultural positions and start your application',
        ctaTitle: 'Ready to Start Your H2-A Visa Process?',
        ctaDescription: 'Contact our team today to learn more about how we can help you with your H2-A visa application. We\'re here to guide you through every step of the process.',
        ctaButton: 'Contact Us Today'
    },
    h2bVisa: {
        title: 'H2-B Visa',
        subtitle: 'Temporary Non-Agricultural Workers Program - Connecting skilled workers with American businesses',
        whatIsTitle: 'What is the H2-B Visa?',
        whatIsDescription1: 'The H2-B visa is a non-immigrant visa that allows U.S. employers to bring foreign nationals to the United States to fill temporary non-agricultural jobs.',
        whatIsDescription2: 'This program addresses labor shortages in various sectors including hospitality, construction, landscaping, food service, and other seasonal or peak-load industries.',
        whatIsDescription3: 'The H2-B visa allows workers to stay in the U.S. for up to one year, with the possibility of extensions for up to three years in total.',
        whoIsForTitle: 'Who is this Visa For?',
        employersTitle: 'For U.S. Employers:',
        employersDescription: 'Businesses in hospitality, construction, landscaping, food service, and other industries that need temporary workers for seasonal or peak-load work.',
        workersTitle: 'For Foreign Workers:',
        workersDescription: 'Skilled workers from eligible countries who are seeking temporary employment opportunities in non-agricultural sectors in the United States.',
        requirementsTitle: 'Basic Requirements:',
        requirementsDescription: 'Must be at least 18 years old, have relevant work experience, and be from a country that has a treaty with the U.S. for this type of visa.',
        benefitsTitle: 'Key Benefits of the H2-B Visa Program',
        benefit1: 'Legal Work',
        benefit1Desc: 'Work legally in the U.S. with proper documentation',
        benefit2: 'Fair Wages',
        benefit2Desc: 'Guaranteed fair wages and working conditions',
        benefit3: 'Housing',
        benefit3Desc: 'Employer-provided housing or housing allowance',
        benefit4: 'Transportation',
        benefit4Desc: 'Transportation to and from the U.S. included',
        howWeHelpTitle: 'How Laboria Helps with H2-B Visa Processing',
        howWeHelpSubtitle: 'We handle the entire process from start to finish',
        step1: '1. Application',
        step1Desc: 'Complete visa application and documentation',
        step2: '2. Processing',
        step2Desc: 'Handle all government processing and approvals',
        step3: '3. Support',
        step3Desc: 'Ongoing support throughout the process',
        step4: '4. Success',
        step4Desc: 'Ensure successful visa approval and arrival',
        clientSectionTitle: 'For U.S. Businesses & Employers',
        clientBenefitsTitle: 'Why Choose H2-B Workers?',
        clientBenefit1: 'Reliable seasonal workforce during peak business periods',
        clientBenefit2: 'Skilled workers with relevant industry experience',
        clientBenefit3: 'Compliance with U.S. labor laws and regulations',
        clientBenefit4: 'Flexible employment periods (up to 3 years)',
        clientRequirementsTitle: 'Employer Requirements',
        clientRequirement1: 'Demonstrate temporary or seasonal need for workers',
        clientRequirement2: 'Pay prevailing wage rates and provide housing',
        clientRequirement3: 'Cover transportation costs to and from the U.S.',
        clientRequirement4: 'Ensure workers\' compensation coverage',
        clientCtaButton: 'Hire H2-B Workers',
        applicantSectionTitle: 'For Workers Seeking U.S. Employment',
        applicantBenefitsTitle: 'Benefits for Workers',
        applicantBenefit1: 'Legal work authorization in the United States',
        applicantBenefit2: 'Competitive wages with fair working conditions',
        applicantBenefit3: 'Employer-provided housing or housing allowance',
        applicantBenefit4: 'Round-trip transportation included',
        applicantRequirementsTitle: 'Worker Requirements',
        applicantRequirement1: 'Minimum 18 years of age',
        applicantRequirement2: 'Proven work experience in relevant industry',
        applicantRequirement3: 'Citizen of eligible treaty country',
        applicantRequirement4: 'Willingness to work temporary positions',
        applicantCtaButton: 'Apply for H2-B Jobs',
        applicantCtaSubtext: 'Browse available positions and start your application',
        ctaTitle: 'Ready to Start Your H2-B Visa Process?',
        ctaDescription: 'Contact our team today to learn more about how we can help you with your H2-B visa application. We\'re here to guide you through every step of the process.',
        ctaButton: 'Contact Us Today'
    }
}

export default {
    translation
}